import { jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import style from './Spinner.module.css.js';

const Spinner = (props) => {
    const color = props.color ?? "#999";
    const sticks = props.stickCount ?? 8;
    const classname = props.className;
    let size = 52.5;
    if (typeof props.size === "number") {
        size = props.size;
    }
    else if (props.size === "sm") {
        size = 42;
    }
    else if (props.size === "lg") {
        size = 78.75;
    }
    return (jsx("div", { className: classNames(style.loader, classname), role: "progressbar", style: { "--color": color, "--sticks": sticks, "--size": `${size}px` }, children: [...new Array(sticks)].map((_, i) => (jsx("div", { style: {
                "--rotation": `${(i * 360) / sticks}deg`,
                "--opacity": (i + 1) * (1 / (sticks + 1)),
            } }, i))) }));
};

export { Spinner };
//# sourceMappingURL=Spinner.js.map
